"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurMilestones() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const milestones = [{
    year: "2015",
    title: "Ruchnii Studios was established with a singular mission: to amplify the lessons of classic children's  stories with the power of cinematic animation.",
    description: "",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/studio_founding_origin.png",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/studio_founding_origin.png-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/studio_founding_origin.png-wvc-sizes",
    imageAlt: "The original founding of Ruchnii Studios in 2018"
  }, {
    year: "2023",
    title: "Harness AI: innovates replacing Unity and Unreal Engine workflows with AI tooling.",
    description: "",
    image: "",
    imageSrcset: "",
    imageSizes: "",
    imageAlt: ""
  }, {
    year: "2026",
    title: "Beta Prototype - create an Agentic AI platform to empower animators and content creators.",
    description: "",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/prototype_development_phase.webp",
    imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/prototype_development_phase.webp-wvc-srcset",
    imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700347/img/prototype_development_phase.webp-wvc-sizes",
    imageAlt: "Development phase of the first animation prototype"
  }];
  return <section data-section-id="762" id="our-milestones" className="bg-background text-foreground py-24 md:py-36">
      <div className="max-w-[1200px] mx-auto px-6">
        {}
        

        {}
        <div className="relative max-w-[900px] mx-auto">
          {}
          <div className="absolute top-0 bottom-0 w-px bg-border left-4 md:left-1/2 md:-translate-x-1/2" aria-hidden="true" />

          <ol className="space-y-16 md:space-y-24">
            {milestones.map((m, i) => {
            const isLeft = i % 2 === 0;
            return <li key={i} data-index={i} className="relative">
                  {}
                  

                  {}
                  <div className="md:hidden pl-12">
                    <TimelineContent year={m.year} title={m.title} description={m.description} image={m.image} imageSrcset={m.imageSrcset} imageSizes={m.imageSizes} imageAlt={m.imageAlt} index={i} />
                  </div>

                  {}
                  <div className="hidden md:grid grid-cols-2 gap-12 items-start">
                    {isLeft ? <>
                        {}
                        <div className="flex justify-end pr-10 text-right">
                          <span className="font-default text-5xl lg:text-[56px] leading-none text-primary">
                            {m.year}
                          </span>
                        </div>
                        {}
                        <div className="pl-10">
                          <TimelineDetails title={m.title} description={m.description} image={m.image} imageSrcset={m.imageSrcset} imageSizes={m.imageSizes} imageAlt={m.imageAlt} index={i} />
                        </div>
                      </> : <>
                        {}
                        <div className="pr-10 flex flex-col items-end text-right">
                          <TimelineDetails title={m.title} description={m.description} image={m.image} imageSrcset={m.imageSrcset} imageSizes={m.imageSizes} imageAlt={m.imageAlt} index={i} align="right" />
                        </div>
                        {}
                        <div className="pl-10">
                          <span className="font-default text-5xl lg:text-[56px] leading-none text-primary">
                            {m.year}
                          </span>
                        </div>
                      </>}
                  </div>
                </li>;
          })}
          </ol>

          {}
          <div className="relative mt-16 md:mt-24 flex justify-start md:justify-center">
            <div className="flex items-center gap-3 pl-12 md:pl-0">
              <span className="size-2.5 bg-foreground rounded-lg" aria-hidden="true" />
              <span className="font-mono text-xs tracking-widest uppercase text-muted-foreground">
                Present Day
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TimelineDetails({
  title,
  description,
  image,
  imageSrcset,
  imageSizes,
  imageAlt,
  index,
  align = "left"
}: {
  title: string;
  description: string;
  image: string;
  imageSrcset: string;
  imageSizes: string;
  imageAlt: string;
  index: number;
  align?: "left" | "right";
}) {
  return <div className={align === "right" ? "max-w-sm" : "max-w-sm"}>
      <div className="flex items-center gap-2 mb-3">
        <span className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="h-px w-8 bg-border" aria-hidden="true" />
      </div>
      <h3 className="font-default text-[22px] leading-snug mb-3">{title}</h3>
      
      {image && <div className={`mt-6 w-[200px] overflow-hidden rounded-lg shadow-md ${align === "right" ? "ml-auto" : ""}`}>
          
          <p className="mt-3 font-mono text-[10px] tracking-widest uppercase text-muted-foreground">
            Pl. {String(index + 1).padStart(2, "0")} — Archive
          </p>
        </div>}
    </div>;
}
function TimelineContent({
  year,
  title,
  description,
  image,
  imageSrcset,
  imageSizes,
  imageAlt,
  index
}: {
  year: string;
  title: string;
  description: string;
  image: string;
  imageSrcset: string;
  imageSizes: string;
  imageAlt: string;
  index: number;
}) {
  return <div>
      <div className="flex items-center gap-2 mb-3">
        <span className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="h-px w-8 bg-border" aria-hidden="true" />
      </div>
      <div className="font-default text-4xl text-primary mb-2 leading-none">
        {year}
      </div>
      <h3 className="font-default text-xl leading-snug mb-3 mt-3">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {description}
      </p>
      {image && <div className="mt-5 w-[160px] overflow-hidden rounded-lg shadow-md">
          <div className="relative w-full" style={{
        aspectRatio: "3 / 4"
      }}>
            <img src={image} data-wvc-srcset={imageSrcset} data-wvc-sizes={imageSizes} alt={imageAlt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          </div>
        </div>}
    </div>;
}